import { Box, IconButton, TextField } from "@mui/material";
import { MaterialReactTable } from "material-react-table";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
} from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { deleteUser } from "../../Utils/actions";
import { loadingOn } from "../../Utils/utils";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tooltip,
} from "@material-ui/core";
import "./VUser.scss";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import LastPageIcon from "@mui/icons-material/LastPage";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import FormControl from "@mui/material/FormControl";
import { Select, MenuItem } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import { buttonStyle } from "../../Style/ManualStyle";
import CloseIcon from "@mui/icons-material/Close";

const ShowAllUser = ({
  onClickEdting,
  onCancelEditing,
  onUserPermission,
  userTablePagination,
  setUserTablePagination,
  pageIndexAddUser,
  setPageIndexAddUser,
  pageSizeAddUser,
  setPageSizeAddUser,
}) => {
  const { allUserdata, userTableCount } = useSelector((state) => state.data);
  // const allUserdata = [
  //     {
  //         username: 'SigmaStream',
  //         fname: 'Sigma',
  //         sname: 'Stream',
  //         mobile: '7973281897',
  //         email: 'sigmaStream#1'
  //     }
  // ]
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [deleteRow, setDeleteRow] = useState({});
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  sessionStorage.setItem("addUserPageSize", pageSizeAddUser);
  // const [pagination, setPagination] = useState({
  //   pageIndex: 1,
  //   pageSize: 10,
  // });

  const columns = useMemo(
    //column definitions...
    () => [
      {
        accessorKey: "username",
        header: "User Name",
        enableEditing: false,
      },
      {
        accessorKey: "email",
        header: "Email",
      },
      {
        accessorKey: "company",
        header: "Company",
      },
      {
        accessorKey: "mobile",
        header: "Mobile No",
      },
    ],
    [t]
    //end
  );

  const cmpntGroup =
    sessionStorage.getItem("cmpntGroup") !== null
      ? JSON.parse(sessionStorage.getItem("cmpntGroup"))
      : "{}";

  const handleDeleteCancel = () => {
    setDeleteConfirm(false);
    setDeleteConfirmOpen(false);
  };

  const handleDeleteConfirm = () => {
    // Handle delete logic here
    setDeleteConfirm(true);
    setDeleteConfirmOpen(false);
  };

  const openDeleteConfirmModal = (row) => {
    setDeleteConfirmOpen(true);
    setDeleteRow(row.original);

    // return (
    //     <>

    //     </>)
  };

  const handleSetUser = (e) => {
    e.preventDefault();
    onUserPermission(true);
    // table.setCreatingRow(true); //simplest way to open the create row modal with no default values
  };

  useEffect(() => {
    if (deleteConfirm) {
      setDeleteConfirm(false);
      dispatch(loadingOn());
      dispatch(deleteUser(deleteRow, pageSizeAddUser, pageIndexAddUser));
    }
  }, [deleteConfirmOpen]);

  const onhandleSave = () => {};

  const onClickListener = ({ row, table }) => {
    onCancelEditing(true);
    table.setEditingRow(null);
  };

  const handlePageChange = (newPageIndex) => {
    setPageIndexAddUser(newPageIndex);
  };
  const handleStartChange = () => {
    setPageIndexAddUser(0);
  };

  const handleEndChange = () => {
    const totalPages = Math.ceil(userTableCount / pageSizeAddUser);
    setPageIndexAddUser(totalPages - 1);
  };

  const handlePageSizeChange = (newPageSize) => {
    setPageSizeAddUser(newPageSize);
    setPageIndexAddUser(0);
  };

  return (
    <div
      className="add-role-content"
      style={{
        display: "block",
        width: "100%",
        overflow: "auto",
        padding: "0px 0px",
        // paddingLeft: "0px !important",
        // paddingRight: "0px",
        // height: "74vh",
      }}
    >
      <MaterialReactTable
        muiTableHeadCellProps={{
          sx: {
            backgroundColor: "#2e2e2e", // dark head
            color: "#ccc",
          },
        }}
        muiTableHeadProps={{
          sx: {
            overflow: "auto",
            backgroundColor: "#2e2e2e",
            "&::-webkit-scrollbar": {
              width: "12px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#444", // darker thumb
              borderRadius: "6px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#555",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "#2e2e2e",
            },
          },
        }}
        muiTableHeadCellContentProps={{
          sx: {
            color: "#ccc !important", // text color
            "& svg": {
              color: "#ccc !important", // sort icon color
            },
          },
        }}
        muiTableBodyProps={{
          sx: {
            overflow: "auto",
            scrollbarWidth: "thin",
            backgroundColor: "#181818", // dark body
            "&::-webkit-scrollbar": {
              width: "12px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#444",
              borderRadius: "6px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#555",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "#23272f",
            },
            "& td": {
              padding: "0.5rem",
              borderBottom: "1px solid #333",
              color: "#c7c7c7",
            },
          },
        }}
        muiTableContainerProps={{
          sx: {
            maxHeight: "59vh",
            overflowY: "auto",
            overflowX: "auto",
            backgroundColor: "#181818", // dark container
          },
        }}
        muiTablePaperProps={{
          sx: {
            boxShadow: "none",
            height: "auto",
            width: "100%",
            position: "static",
            display: "block",
            overflowY: "auto",
            overflowX: "auto",
            backgroundColor: "#23272f", // dark table background
            scrollbarWidth: "thin",
            "&::-webkit-scrollbar": {
              width: "12px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#444",
              borderRadius: "6px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#555",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "#23272f",
            },
          },
        }}
        muiTableBodyRowProps={({ row, index }) => ({
          sx: {
            backgroundColor: row.getIsSelected()
              ? "#1c1c1c"
              : // : index % 2 === 0
                // ? "#cfd5e959"
                "#121212",
            color: "#ccc",
          },
        })}
        columns={columns}
        data={allUserdata}
        enableRowActions
        enableStickyHeader={true}
        enableStickyFooter={true}
        positionActionsColumn="last"
        editDisplayMode="row"
        enableDensityToggle={false}
        enableFullScreenToggle={false}
        // enableFilters={false}
        enableHiding={false}
        createDisplayMode="custom"
        muiPaginationProps={({ table }) => ({
          showRowsPerPage: true,
        })}
        rowCount={userTableCount}
        state={userTablePagination}
        muiTableHeadCellFilterTextFieldProps={{
          sx: {
            input: {
              "&::placeholder": {
                color: "#ffffff",
                opacity: 1,
              },
            },
          },
        }}
        renderTopToolbar={({ table }) => (
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
              padding: "0.5rem 1rem",
              flexWrap: "wrap",
              gap: "1rem",
              background: "#181818",
            }}
          >
            {/* Left: Custom Search Field */}
            <TextField
              variant="outlined"
              size="small"
              placeholder="Search..."
              value={table.getState().globalFilter || ""}
              onChange={(e) => table.setGlobalFilter(e.target.value)}
              sx={{
                minWidth: "250px",
                input: { color: "#c7c7c7", background: "#272727" },
                "& legend": {
                  display: "none",
                },
              }}
            />

            {/* Right: Filter + Create Button */}
            <div
              style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
            >
              {/* Just the filter icon (toggle column filters) */}
              <Tooltip title="Show Filters">
                <IconButton
                  onClick={() =>
                    table.setShowColumnFilters(
                      !table.getState().showColumnFilters
                    )
                  }
                >
                  <FilterListIcon sx={{ color: "#c7c7c7 !important" }} />
                </IconButton>
              </Tooltip>

              {/* Create Button */}
              {JSON.parse(sessionStorage.getItem("isAuthenticated")) ? (
                cmpntGroup["user"]?.Add && (
                  <Tooltip title="Add User">
                    <Button
                      startIcon={<AddIcon />}
                      style={{
                        marginRight: "10px",
                        width: "100px",
                        padding: "5px 10px",
                        background: "linear-gradient(135deg, #4f4f4f, #1e1e1e)",
                        border: "1px solid #3a3a3a",
                        color: "#ffffff",
                        fontSize: "5px",
                        borderRadius: "6px",
                        cursor: "pointer",
                        boxShadow: "0 0 8px rgba(0, 0, 0, 0.6)",
                        transition: "background 0.3s ease, transform 0.2s ease",
                      }}
                      onClick={(e) => handleSetUser(e)}
                    >
                      Create
                    </Button>
                  </Tooltip>
                )
              ) : (
                <Tooltip title="Add User">
                  <Button
                    startIcon={<AddIcon />}
                    style={{
                      padding: "5px 10px",
                      background: "linear-gradient(135deg, #4f4f4f, #1e1e1e)",
                      border: "1px solid #3a3a3a",
                      color: "#ffffff",
                      /* font-weight: 600; */
                      fontSize: "5px",
                      borderRadius: "6px",
                      cursor: "pointer",
                      boxShadow: "0 0 8px rgba(0, 0, 0, 0.6)",
                      transition: "background 0.3s ease, transform 0.2s ease",
                      marginRight: "10px",
                      width: "100px",
                    }}
                    onClick={(e) => handleSetUser(e)}
                  >
                    Create
                  </Button>
                </Tooltip>
              )}
            </div>
          </div>
        )}
        enablePagination={false}
        renderBottomToolbarCustomActions={({ table }) => (
          <>
            <div style={{ marginLeft: "auto", color: "#c7c7c7" }}>
              <span>Rows per Page </span>&nbsp;
              <FormControl variant="standard" size="small">
                <Select
                  value={pageSizeAddUser}
                  onChange={(e) => handlePageSizeChange(Number(e.target.value))}
                  sx={{
                    color: "#c7c7c7",
                    ".MuiSelect-icon": { color: "#c7c7c7" },
                    ".MuiOutlinedInput-notchedOutline": {
                      borderColor: "#444",
                    },
                  }}
                >
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                  <MenuItem value={100}>100</MenuItem>
                </Select>
              </FormControl>
              &nbsp;
              <span>
                {pageIndexAddUser * pageSizeAddUser + 1}-
                {Math.min(
                  pageIndexAddUser * pageSizeAddUser + pageSizeAddUser,
                  userTableCount
                )}{" "}
                of &nbsp;
                {userTableCount}&nbsp;
              </span>
              <FirstPageIcon
                onClick={() => {
                  if (pageIndexAddUser !== 0) {
                    handleStartChange();
                  }
                }}
                style={{
                  cursor: pageIndexAddUser === 0 ? "not-allowed" : "pointer",
                  color:
                    pageIndexAddUser === 0
                      ? "rgba(255,255,255,0.26)"
                      : "#c7c7c7",
                }}
              />
              <NavigateBeforeIcon
                onClick={() => {
                  if (pageIndexAddUser !== 0) {
                    handlePageChange(pageIndexAddUser - 1);
                  }
                }}
                style={{
                  cursor: pageIndexAddUser === 0 ? "not-allowed" : "pointer",
                  color:
                    pageIndexAddUser === 0
                      ? "rgba(255,255,255,0.26)"
                      : "#c7c7c7",
                }}
              />
              <NavigateNextIcon
                onClick={() => {
                  if (
                    (pageIndexAddUser + 1) * pageSizeAddUser <
                    userTableCount
                  ) {
                    handlePageChange(pageIndexAddUser + 1);
                  }
                }}
                style={{
                  cursor:
                    (pageIndexAddUser + 1) * pageSizeAddUser >= userTableCount
                      ? "not-allowed"
                      : "pointer",
                  color:
                    (pageIndexAddUser + 1) * pageSizeAddUser >= userTableCount
                      ? "rgba(255,255,255,0.26)"
                      : "#c7c7c7",
                }}
              />
              <LastPageIcon
                onClick={() => {
                  if (
                    (pageIndexAddUser + 1) * pageSizeAddUser <
                    userTableCount
                  ) {
                    handleEndChange();
                  }
                }}
                style={{
                  cursor:
                    (pageIndexAddUser + 1) * pageSizeAddUser >= userTableCount
                      ? "not-allowed"
                      : "pointer",
                  color:
                    (pageIndexAddUser + 1) * pageSizeAddUser >= userTableCount
                      ? "rgba(255,255,255,0.26)"
                      : "#c7c7c7",
                }}
              />
            </div>
          </>
        )}
        renderRowActions={({ row, table }) => (
          <Box sx={{ display: "flex", flexWrap: "nowrap", gap: "8px" }}>
            {/* <IconButton
                        color="primary"
                        onClick={() =>
                        window.open(
                            `mailto:kevinvandy@mailinator.com?subject=Hello ${row.original.firstName}!`,
                        )
                        }
                    >
                        <EmailIcon />
                    </IconButton> */}
            {JSON.parse(sessionStorage.getItem("isAuthenticated")) ? (
              cmpntGroup["user"]?.Update && (
                <Tooltip title="Edit User">
                  <IconButton
                    sx={{ color: "#000" }}
                    onClick={() => {
                      table.setEditingRow(row);
                      onClickEdting(row);
                    }}
                  >
                    <EditIcon sx={{ color: "#c7c7c7" }} />
                  </IconButton>
                </Tooltip>
              )
            ) : (
              <Tooltip title="Edit User">
                <IconButton
                  sx={{ color: "#000" }}
                  onClick={() => {
                    table.setEditingRow(row);
                    onClickEdting(row);
                  }}
                >
                  <EditIcon sx={{ color: "#c7c7c7" }} />
                </IconButton>
              </Tooltip>
            )}
            {JSON.parse(sessionStorage.getItem("isAuthenticated")) ? (
              cmpntGroup["user"]?.Delete && (
                <Tooltip title="Delete User">
                  <IconButton
                    // sx={{ color: "#286685" }}
                    onClick={() => {
                      openDeleteConfirmModal(row);
                      // data.splice(row.index, 1); //assuming simple data table
                      // setData([...allUserdata]);
                    }}
                  >
                    <DeleteIcon sx={{ color: "#c7c7c7" }} />
                  </IconButton>
                </Tooltip>
              )
            ) : (
              <Tooltip title="Delete User">
                <IconButton
                  // sx={{ color: "#286685" }}
                  onClick={() => {
                    openDeleteConfirmModal(row);
                    // data.splice(row.index, 1); //assuming simple data table
                    // setData([...allUserdata]);
                  }}
                >
                  <DeleteIcon sx={{ color: "#c7c7c7" }} />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        )}
      />
      <div>
        <Dialog open={deleteConfirmOpen} onClose={handleDeleteCancel}>
          <DialogTitle style={{ backgroundColor: "#161616", color: "#c7c7c7" }}>
            Delete Confirmation
          </DialogTitle>
          <DialogContent sx={{ backgroundColor: "#23272f", color: "#c7c7c7" }}>
            <p>Are you sure you want to delete the item?</p>
          </DialogContent>
          <DialogActions style={{ color: "#c7c7c7" }}>
            <Button
              startIcon={<CloseIcon />}
              onClick={handleDeleteCancel}
              style={buttonStyle}
              variant="contained"
            >
              Cancel
            </Button>
            <Button
              startIcon={<DeleteIcon />}
              onClick={handleDeleteConfirm}
              // variant="contained"
              disableElevation
              style={buttonStyle}
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
};

export default ShowAllUser;
